import React, { FC, PropsWithChildren } from 'react';
import { DH } from '../../../utils/DataHook';

export const WidgetContainer: FC<PropsWithChildren> = ({ children }) => (
  <div data-hook={DH.WidgetContainer}>{children}</div>
);
